export default __webpack_public_path__ + "static/media/faviconAbb.935e5ed0.ico";